<span class="d-inline-block" *ngIf="paymentInfo?.PaymentMethodType === paymentMethodType?.CreditCard">
    <span [class.cc-mastercard]="currentCCType === ccpaymentType.MasterCard"
      [class.cc-visa]="currentCCType === ccpaymentType.Visa"
      *ngIf="paymentInfo?.PaymentMethodType === paymentMethodType?.CreditCard"></span>
  
    <span class="ml-5" *ngIf="displayCCForm"> &nbsp;{{resourcesService.getViewResource( "PaymentInformation_Text_CreditCardEndingIn")}}</span>
    <span *ngIf="displayCCForm"> {{last4CardNumber}}</span>
  </span>
  
  <span class="d-inline-block" *ngIf="paymentInfo?.PaymentMethodType === paymentMethodType?.IBAN">
    &nbsp;{{resourcesService.getViewLabel( "PaymentInformation_Text_IBANEndingIn")}}
    <span> {{last4CardNumber}}</span>
  </span>
  <span class="d-inline-block" *ngIf="paymentInfo?.PaymentMethodType === paymentMethodType?.Cheque">
    &nbsp;{{resourcesService.getViewLabel( "PaymentInformation_Text_Check")}}
    <!-- <span> {{"CHECK"}}</span> -->
  </span>